import { Popup } from '../../../../ui/popup/popup';
import { rootActions, useAppDispatch, useAppSelector } from '../../DAL/store';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

const TopPopup = () => {

    const dispatch = useAppDispatch();

    const $popupContent = document.getElementById('eligible-popup-content') as HTMLElement;

    const PageData = useAppSelector(store => store.PageData);

    const onClose = () => {
        dispatch(
            rootActions.main({
                isTopPopupOpened: false,
            })
        );
    };

    const termsOnClick = () => {
        sendGAEvent('Free Plugins', 'terms and conditions');
    };

    const shopAllClick = () => {
        sendGAEvent('Free Plugins', 'Shop All Button');
    };

    return (
        <Popup width="600px" height="500px" close={ onClose }>
            {
                $popupContent &&
                <>
                    <div className="pt-8 md:px-6" dangerouslySetInnerHTML={{__html: $popupContent.innerHTML}}/>

                    {
                        PageData.campaignDetails.buttonText &&
                        <a
                            href={PageData.campaignDetails.buttonURL}
                            className="w-btn mx-auto w-fit px-8 mt-8"
                            onClick={shopAllClick}>{PageData.campaignDetails.buttonText}</a>
                    }

                    {
                        PageData.campaignDetails.tcurl &&
                        <a href={PageData.campaignDetails.tcurl} className="mt-4"
                           onClick={termsOnClick}>See terms and conditions</a>
                    }
                </>
            }
        </Popup>
    )
};

export default TopPopup;